<template>
  <el-breadcrumb separator="/" class="breadcrumb">
    <el-breadcrumb-item :key="index" v-for="(item,index) in items">
      <a v-if="item.path" @click="handleClick(item.path)">{{item.name}}</a>
      <span v-else>{{item.name}}</span>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
  import menus from '@constants/menu';
  import getRouterConf from '@util/getRouterConf';

  export default {
    data () {
      return {
        items: []
      };
    },
    watch: {
      '$route': function () {
        this.items = this.getTitle();
      }
    },
    methods: {
      getTitle () {
        const {title} = this.$route.meta;
        if (title && typeof title === 'string') {
          return [{name: title}];
        } else if (title && typeof title === 'object') {
          return title;
        } else {
          if (this.$route.path === '/Midware') {
            return;
          }
          return [{name: getRouterConf(this.$route.path)[1].name}];
        }
      },
      handleClick (path) {
        this.$router.push({
          path
        });
      }
    },
  };
</script>

<style lang="less">
  .breadcrumb {
    height: 40px;
    line-height: 40px;
    background: white;
    font-size: 14px;
    color: #333333;
    letter-spacing: -0.34px;
    font-weight: bold;
    .el-breadcrumb__item:first-child {
      margin-left: 21px;
    }
  }
</style>



// WEBPACK FOOTER //
// BreadCrumb.vue?1c940ca1